import React, { useState, useEffect } from 'react';
import { WifiOff, ShieldAlert } from 'lucide-react';

export function OfflineBadge() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-center bg-red-600 text-white text-xs py-1 px-4 shadow-md sm:text-sm">
      <WifiOff className="mr-2" size={16} />
      <span className="font-bold">MODO OFFLINE</span>
      <span className="ml-2 hidden sm:inline">- Algunas funciones comerciales se restaurarán al recuperar la conexión.</span>
    </div>
  );
}
